<div *ngIf="message" [ngClass]="message.cssClass">
    {{message.text}}
    <button (click)="alertService.clear()">&times;</button>
</div>